import { MICROSERVICIOS } from "../../CONSTANTS/constants";
import { Request } from "../../CONSTANTS/request";
import { RequestResponse } from "../../DTO/requestResponse";

export default class EncargoRuteo {


        // EncargoRuteo.getPingPRD() <- asi se usa
        static async getPingPRD(): Promise<RequestResponse> {
            return new Request(MICROSERVICIOS.ENCARGO_RUTEO_PRD).getEncargoRuteoPRD('Ping');
        }
    
           // EncargoRuteo.getPingqa() <- asi se usa
           static async getPingQA(): Promise<RequestResponse> {
    
            return new Request(MICROSERVICIOS.ENCARGO_RUTEO_QA).getEncargoRuteoQA('Ping');
        }

        
        // EncargoRuteo.getPingPRD() <- asi se usa
        static async getPingOraclePRD(): Promise<RequestResponse> {
            return new Request(MICROSERVICIOS.ENCARGO_RUTEO_PRD).getEncargoRuteoPRD('PingOracle');
        }
    
           // EncargoRuteo.getPingqa() <- asi se usa
           static async getPingOracleQA(): Promise<RequestResponse> {
    
            return new Request(MICROSERVICIOS.ENCARGO_RUTEO_QA).getEncargoRuteoQA('PingOracle');
        }

}